import { useEffect, useState } from 'react'
import { request } from 'graphql-request'
import { baseUrl } from 'services/shared/Environment'
import { categoriesQuery } from './Footer.constants'

export function useCategories() {
    
    const [categories, setCategories] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchData = async () => {
            const result = await request(`${baseUrl()}/api/graphql`, categoriesQuery)
            setCategories(result?.categories ?? [])
            setLoading(false)
        }
        fetchData()
    }, [])

    return { categories, loading };
}